import {DownloadStateType} from "@/store/interfaces/IDownload";

export default {
    state: (): DownloadStateType => ({
        version_id: 0,
        title: '',
    }),
    mutations: {
        createDownloadRequest(state: DownloadStateType, obj: { version_id: number; title: string }) {
            state.version_id = obj.version_id
            state.title = obj.title
        },
        updateDownloadVersion(state: DownloadStateType, data: any) {
            state.version_id = data
        },
    },
    getters: {
        getDownloadRequest(state: DownloadStateType): DownloadStateType {
            return state
        }
    }
}